var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 79.1666V20.8333C16.6667 13.9291 22.2625 8.33325 29.1667 8.33325H58.3334L83.3334 33.3332V79.1666C83.3334 86.0707 77.7375 91.6666 70.8334 91.6666H29.1667C22.2625 91.6666 16.6667 86.0707 16.6667 79.1666Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 24.9999V8.33325L83.3333 33.3333H66.6666C62.0625 33.3333 58.3333 29.6041 58.3333 24.9999Z",
    fill: "url(#paint0_linear_334_23133)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 54.1666H37.5C35.1959 54.1666 33.3334 52.2999 33.3334 49.9999C33.3334 47.6999 35.1959 45.8333 37.5 45.8333H62.5C64.8042 45.8333 66.6667 47.6999 66.6667 49.9999C66.6667 52.2999 64.8042 54.1666 62.5 54.1666Z",
    fill: "url(#paint1_linear_334_23133)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 70.8333H37.5C35.1959 70.8333 33.3334 68.9667 33.3334 66.6667C33.3334 64.3667 35.1959 62.5 37.5 62.5H54.1667C56.4709 62.5 58.3334 64.3667 58.3334 66.6667C58.3334 68.9667 56.4709 70.8333 54.1667 70.8333Z",
    fill: "url(#paint2_linear_334_23133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_23133",
    x1: 70.8333,
    y1: 8.33325,
    x2: 70.8333,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_23133",
    x1: 50,
    y1: 45.8333,
    x2: 50,
    y2: 54.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_23133",
    x1: 45.8334,
    y1: 62.5,
    x2: 45.8334,
    y2: 70.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDocument);
export default __webpack_public_path__ + "static/media/dark-document.f7db8fc336d89e2209cdbacedaa0333c.svg";
export { ForwardRef as ReactComponent };